__turbopack_context__.v({
  "address": "styles-module__gR3QPq__address",
  "body": "styles-module__gR3QPq__body",
  "item": "styles-module__gR3QPq__item",
  "price": "styles-module__gR3QPq__price",
  "priceRow": "styles-module__gR3QPq__priceRow",
  "priceSmall": "styles-module__gR3QPq__priceSmall",
  "shimmer": "styles-module__gR3QPq__shimmer",
  "thumb": "styles-module__gR3QPq__thumb",
  "wrap": "styles-module__gR3QPq__wrap",
});
